import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import OtpInput from 'react-otp-input';
import { HiOutlineArrowNarrowLeft } from 'react-icons/hi';
import { IoCloseSharp } from 'react-icons/io5';
import { PropsFromRedux } from '.';
import  './ConfirmWalletPin.scss';
import { BeatLoader } from '../Spinners/Spinner';


interface Props extends PropsFromRedux {}


const ConfirmWalletPin: React.FC<Props> = ({ 
  hideModal,
  showModal,
  modal,
  loginState,
  resendOtp,
  resendOtpState
 }) => {

  const { loading, error, response  } = resendOtpState || {};

  const walletpin = modal?.ownProps?.walletpin; 

  const [otp,setOtp] = useState('')

  const handleChange = (code:any) => { setOtp(code) }

  const closeModal = () => {
    hideModal();
  };

  const getOtp = () => {
    if (otp == walletpin) {
      resendOtp({
        Email: loginState?.request?.UserDetail,
        PhoneNumber: loginState?.request?.UserDetail
      });
    }
  }

  const BackReset = () => {
    showModal({
      component: 'WalletPinSetup',
      modalProps: {
        contentLabel: 'Wallet Pin Setup',
      }
    });
  }

  React.useEffect(() => {
  if (otp == walletpin && resendOtpState?.success && resendOtpState?.response?.Object.EmailSent === true) {
      showModal({
        component: 'WalletPinOtp',
        modalProps: {
          contentLabel: 'Walletpin Otp',
        },
        ownProps: { 
          walletpin : otp
        },
      });
    }
  }, [resendOtpState?.success && resendOtpState?.response?.Object]);


  // <ModalWrapper hideCloseButton hideModal={hideModal}>
  return(
    <div className="w-full px-8 bg-white lg:px-24 py-10 relative">
          <Link className="mb-10 lg:mb-0 font-bold"to={{ pathname: '' }}  onClick={() => BackReset()}>
          <HiOutlineArrowNarrowLeft className="inline-flex text-2xl -mt-10 font-bold mr-3" />
          </Link>
        <button type="button" aria-label="Close" onClick={closeModal}>
        <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
      </button>
     <div className="w-full my-2 text-center">
         <h2 className="mb-1 text-2xl font-bold text-black">Confirm wallet pin set up</h2>
      </div>
      <div className="w-full max-w-md mx-auto text-center mb-10 text-sm">
        <p className="text-gray-500 my-4">
            Kindly confirm your one-time wallet pin
       </p>
       <div>
       <OtpInput 
       inputStyle="otp-field"
        value={otp}
        onChange={handleChange}
        numInputs={4}
        isInputSecure={true}
        separator={<span> </span>}
      />
       </div>
      </div>
      <button className="w-full bg-secondary font-medium text-sm rounded text-white py-4" type="button" onClick={() => getOtp()}
      disabled={resendOtpState?.loading}
      >{resendOtpState?.loading ? <BeatLoader color="white" /> : 'Confirm'}</button>
          {otp.length == 4 && otp !== walletpin ? (<p className="text-red-600 text-center m-2">Pin don't match</p>) : (
          <div className="text-center">
             <span className="inline-flex items-center">
                  <p className="text-red-600 text-xs"> </p>
            </span>
          </div>
           )}
  </div>
  );
};

export default ConfirmWalletPin;
